export default log;

function log(label) {
  var map = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (x) {
    return x;
  };

  if (!global.localStorage) return;
  if (!global.localStorage.getItem('cv-log')) return;

  var nextLabel = '[ NXT > ' + label + ' ]';
  var errorLabel = '[ ERR > ' + label + ' ]';
  var completeLabel = '[ COM > ' + label + ' ]';

  return console.groupCollapsed ? { next: next, error: error, complete: complete } : { next: nextSimple, error: errorSimple, complete: complete };

  function complete() {
    console.info(completeLabel);
  }

  function next(n) {
    console.groupCollapsed(nextLabel);
    console.log(map(n));
    console.groupEnd(nextLabel);
  }

  function error(e) {
    console.groupCollapsed(errorLabel);
    console.warn(e);
    console.groupEnd(errorLabel);
  }

  function nextSimple(n) {
    console.log(nextLabel, n);
  }

  function errorSimple(n) {
    console.error(errorLabel, n);
  }
}